/* src/components/ProvideVideo.js */
import React, { useState } from 'react';
import { XCircle } from 'lucide-react';
import { validateVideoUrl } from '../services/videoService';

const ProvideVideo = ({ onClose, onSelect }) => {
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = () => {
    setError('');
    const data = validateVideoUrl(url.trim());
    if (!data) {
      setError('Only YouTube, Vimeo or Dailymotion links are allowed.');
      return;
    }
    
    setBusy(true);
    // simulate small UX delay so button shows spinner
    setTimeout(() => {
      onSelect(data);     // AddMedia will know current placeholder id
      setBusy(false);
    }, 300);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md flex flex-col overflow-hidden">
        <header className="flex items-center justify-between border-b p-4">
          <h1 className="text-xl font-bold">Provide Video</h1>
          <button 
            className="text-gray-600 hover:text-black" 
            onClick={onClose}
          >
            <XCircle size={24} />
          </button>
        </header>

        <main className="p-6 space-y-4 flex-1 overflow-auto">
          <input
            type="text"
            placeholder="https://www.youtube.com/watch?v=..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-black"
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <p className="text-sm text-gray-600">
            Please provide a YouTube, Vimeo or Dailymotion URL.
          </p>
        </main>

        <footer className="border-t p-4 flex justify-end space-x-3">
          <button 
            onClick={onClose} 
            className="px-4 py-2 bg-gray-200 rounded"
          >
            Cancel
          </button>
          <button
            disabled={busy}
            onClick={handleSubmit}
            className={`px-4 py-2 text-white rounded ${busy ? "bg-gray-500" : "bg-black hover:bg-gray-800"}`}
          >
            {busy ? "Adding..." : "Add Video"}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ProvideVideo;